/* eslint-disable react-hooks/exhaustive-deps */
import { useQuery } from '@tanstack/react-query';
import useQueryAgent from '~/hooks/useQueryAgent';
import { useMemo } from 'react';

export default function useViewDictionaryQuery(
  apiName,
  { enabled = true, formatter, formatterArgs }
) {
  const { fetchDataDictionary } = useQueryAgent();
  const queryMethods = useQuery({
    queryKey: [apiName],
    queryFn: ({ queryKey }) => fetchDataDictionary(queryKey),
    enabled,
  });

  const { data: queryData } = queryMethods;

  const transformedData = useMemo(() => {
    if (typeof formatter === 'function')
      return formatter((queryData && queryData?.data) || [], formatterArgs);
    return queryData && queryData?.data;
  }, [queryData, formatterArgs]);

  return { ...queryMethods, transformedData };
}
